// Category configuration for the dedicated Trucks and Agriculture tuning
// database trees (/tuning-database/trucks, /tuning-database/agriculture).
// Cars & Vans keeps its existing /tuning/... tree — untouched.

export const TUNING_CATEGORIES = {
  trucks: {
    slug: "trucks",
    name: "Trucks & HGV",
    shortName: "Trucks",
    vehicleNoun: "truck",
    vehicleNounPlural: "trucks",
    basePath: "/tuning-database/trucks",
    indexTitle: "Truck & HGV Tuning Database | Stage 1 Remap Figures | Regal Tuning",
    indexDesc:
      "Truck and HGV ECU remapping database: verified Stage 1 tuning gains for tractors units, rigids and commercial vehicles from DAF, Scania, Volvo Trucks, MAN, Mercedes Trucks, Iveco and more. Compare factory BHP and torque against tuned figures.",
    indexH1: "Truck & HGV Tuning Database",
    indexOverline: "Commercial Vehicle Tuning Gains",
    indexIntro:
      "Verified ECU remapping gains for trucks and heavy goods vehicles — better pulling power, stronger torque for heavy loads and improved fuel flexibility for fleet work. Choose a manufacturer to browse every covered model and engine variant.",
    makeTitle: (make) => `${make} Truck ECU Remapping & Stage 1 Tuning Data | Regal Tuning`,
    makeH1: (make) => `${make} Truck Tuning & ECU Remapping`,
    makeDesc: (make, vehicles, models) =>
      `${make} truck tuning database: verified Stage 1 ECU remap gains for ${vehicles} ${make} trucks across ${models} models. Compare factory BHP and torque against tuned figures, then request your quote from Regal Tuning.`,
    modelTitle: (make, model) => `${make} ${model} ECU Remapping & Tuning Specifications | Regal Tuning`,
    modelDesc: (make, model, count) =>
      `${make} ${model} tuning specifications: factory and Stage 1 ECU remap figures for ${count} engine variant${count === 1 ? "" : "s"}. Verified truck remapping data from Regal Tuning.`,
    vehicleTitleTag: "Truck Remap",
  },
  agriculture: {
    slug: "agriculture",
    name: "Agriculture",
    shortName: "Agriculture",
    vehicleNoun: "machine",
    vehicleNounPlural: "machines",
    basePath: "/tuning-database/agriculture",
    indexTitle: "Agricultural Tuning Database | Tractor Stage 1 Remap Figures | Regal Tuning",
    indexDesc:
      "Agricultural ECU remapping database: Stage 1 tuning data for tractors, combine harvesters, forage harvesters and self-propelled machinery from John Deere, Fendt, Case IH, New Holland, Claas, Massey Ferguson and more.",
    indexH1: "Agricultural Tuning Database",
    indexOverline: "Agricultural Tuning Gains",
    indexIntro:
      "ECU remapping data for tractors, combines, foragers and self-propelled agricultural machinery — more power and torque for heavy draft work, conservatively calibrated for engines that run all day under sustained load. Choose a manufacturer to browse every covered model and engine variant.",
    makeTitle: (make) => `${make} Tractor ECU Remapping & Stage 1 Tuning Data | Regal Tuning`,
    makeH1: (make) => `${make} Agricultural Tuning & ECU Remapping`,
    makeDesc: (make, vehicles, models) =>
      `${make} agricultural tuning database: Stage 1 ECU remap figures for ${vehicles} ${make} tractors and machines across ${models} models. Compare factory horsepower and torque against tuned figures from Regal Tuning.`,
    modelTitle: (make, model) => `${make} ${model} ECU Remapping & Tuning Specifications | Regal Tuning`,
    modelDesc: (make, model, count) =>
      `${make} ${model} tuning specifications: factory and Stage 1 ECU remap figures for ${count} engine variant${count === 1 ? "" : "s"}. Agricultural remapping data from Regal Tuning.`,
    vehicleTitleTag: "Remap",
  },
};

export const ESTIMATE_NOTE =
  "Estimated figures are based on engine, ECU and comparable application data. Actual results can vary depending on software version, machine condition and configuration.";
